"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParagraphAlignmentDestination = void 0;
var tslib_1 = require("tslib");
var paragraph_properties_1 = require("../../../../../core/model/paragraph/paragraph-properties");
var string_1 = require("@devexpress/utils/lib/utils/string");
var translation_tables_1 = require("../../../../translation-table/translation-tables");
var paragraph_formatting_leaf_element_destination_1 = require("../paragraph-formatting-leaf-element-destination");
var ParagraphAlignmentDestination = (function (_super) {
    tslib_1.__extends(ParagraphAlignmentDestination, _super);
    function ParagraphAlignmentDestination() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ParagraphAlignmentDestination.prototype.processElementOpen = function (reader) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var value;
            return tslib_1.__generator(this, function (_a) {
                value = reader.getAttributeNS('val', this.data.constants.wordProcessingNamespaceConst);
                if (!string_1.StringUtils.isNullOrEmpty(value))
                    this.setProperty(this.data.readerHelper.getWpEnumValueCore(value, translation_tables_1.TranslationTables.paragraphAlignmentTable.importMap, paragraph_properties_1.ParagraphAlignment.Left));
                return [2];
            });
        });
    };
    ParagraphAlignmentDestination.prototype.getDescriptor = function () {
        return paragraph_properties_1.ParagraphPropertyDescriptor.alignment;
    };
    return ParagraphAlignmentDestination;
}(paragraph_formatting_leaf_element_destination_1.ParagraphFormattingLeafElementDestination));
exports.ParagraphAlignmentDestination = ParagraphAlignmentDestination;
